import { Injectable, Inject } from '@angular/core';

import { CAN_ACTIVATE_PREFERENCE_CENTER } from '@common/app/app.config';

@Injectable({
    providedIn: 'root',
})
export class PrefCenterGuard  {
    constructor(
        @Inject(CAN_ACTIVATE_PREFERENCE_CENTER)
        private canActivatePreferenceCenter: boolean,
    ) {}
    canActivate(): boolean {
        return this.canActivatePreferenceCenter;
    }
}
